/* eslint-disable @next/next/no-img-element */
import React from 'react';
import Image from 'next/image';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import Icon from '../atoms/Icon';
import Property from '../atoms/Property';
import { toLocationStr } from '../../lib/utils';
import { convertImageIDToURL } from '../../lib/apis/image';
import styles from '../../styles/components/molecules/ItemListed.module.scss';
import { useAppSelector } from '../../app/hooks';
import { isMetric } from '../../features/metrics/metricsSlice';
import Img, { cloudflareLoader } from '../atoms/Img';

interface ItemListedProps {
  className?: string;
  icon?: string;
  tiny?: boolean;
  small?: boolean;
  medium?: boolean;
  large?: boolean;
  hero?: boolean;
  disabled?: boolean;
  data: any; //Partial<Venue>;
}

export default function ItemListed(props: ItemListedProps) {
  const { t } = useTranslation(['common', 'venue', 'rating']);
  const { data: venue, large, medium, disabled, className } = props;
  const {
    slug,
    type,
    name,
    location,
    country,
    city,
    plan,
    images,
    cities,
    rating,
    rates,
    specs,
    status,
    logo_image_id,
  } = venue as any;
  const metricState = useAppSelector(isMetric);
  const { address } = location || {};
  const itemSize =
    large || plan === 'PLATINUM'
      ? 'large'
      : medium || plan === 'GOLD'
      ? 'medium'
      : 'small';
  const img = (images || []).filter((img: any) => img.type !== 'LOGO')[0] || {};
  const { url, image_id } = img;
  const imageSrc = image_id ? convertImageIDToURL(image_id) : url || '';
  const promoted = ['GOLD', 'PLATINUM'].indexOf(plan) > -1; // status === 'promoted'????
  const locationStr = cities
    ? cities.length
      ? cities
          .slice(0, 5)
          .map((el: any) => el.city)
          .join(' - ')
      : toLocationStr(address, plan !== 'PLATINUM')
    : '';
  const classes = clsx(
    styles.itemListed,
    { [styles.disabled]: disabled },
    styles[itemSize],
    className
  );
  const href = slug
    ? `/${type}/${country}/${city}/${slug}`
    : '/promote-your-business/create';
  return (
    <div className={classes}>
      <Link href={href}>
        <a>
          <figure>
            <figcaption>
              <p>
                <b>{name}</b>
                {!!locationStr && (
                  <>
                    <br /> {locationStr}
                  </>
                )}
                {promoted && (
                  <Property icon={'promoted'} label={t(`common:promoted`)} />
                )}
              </p>
              <ul>
                <li>
                  {promoted && (
                    <Property icon={'promoted'} label={t(`common:promoted`)} />
                  )}
                </li>
                {!!specs?.length &&
                  specs.map((el: any, i: number) => {
                    const element = { ...el };

                    if (el.unit === 'sqm' && !metricState) {
                      element.value = Math.round(el.value * 10.764);
                      element.unit = t('common:sqft');
                    }

                    return (
                      <li key={i}>
                        <Property
                          icon={element.id}
                          value={element.value}
                          unit={element.unit}
                        />
                      </li>
                    );
                  })}
              </ul>
            </figcaption>

            <div>
              {imageSrc && (
                <Image
                  loader={cloudflareLoader}
                  src={imageSrc}
                  alt={''}
                  layout="fill"
                  objectFit="cover"
                />
              )}
              {!imageSrc && logo_image_id && (
                <Image
                  loader={cloudflareLoader}
                  src={convertImageIDToURL(logo_image_id, 'logo')}
                  alt={''}
                  className={styles.logo}
                  layout="fill"
                  objectFit="contain"
                />
              )}
              {!imageSrc && !logo_image_id && <Icon name={`${type}s`} />}
            </div>
          </figure>
        </a>
      </Link>
    </div>
  );
}
